export const PRESCRIPTION_XLSX_HEADER_MAP: Record<string, string> = {
  drugCode: '의약품 코드',
  outHospitalQuantity: '원외 사용량',
  inHospitalQuantity: '원내 사용량',
};
